<template>
  <div class="details-page cursorBox bg000">
    <div v-if="apiShow">
      <PcHeader :parseVal="parseVal" :languageData="languageData" />

      <div v-if="loadingShow" class="main">
        <div
          class="game-content"
          :style="{ 'background-image': 'url(' + detail.bgImg + ')' }"
        >
          <img :src="detail.cover" class="game-cover" />
          <div class="info-wrap">
            <div class="nav">
              <router-link to="/home">{{filterFn('otherText', 'crumbs1')}}</router-link> -
              <router-link to="/pc/gameDisplay">{{filterFn('otherText', 'crumbs2')}}</router-link> -
              <span>{{filterCrumbsFn()}}</span> -
              <span>{{ detail.name }}</span>
            </div>
            <div class="game-title">{{ detail.name }}</div>

            <div class="flex-row">
              <div class="describe">
                <div>{{ detail.describe }}</div>
              </div>
              <div class="flex-column">
                <span class="link-btn" @click="toLink">PLAY</span>
              </div>
            </div>
          </div>
        </div>
        <div class="game-rightBox">
          <div class="game-specs">
            <div class="flex-row-between">
              <div class="left-info">
                <div :class="{'flex': !detail.isVertical}">
                  <div>
                    <div class="specs-title">{{filterFn('otherText', 'specification')}}</div>
                    <div class="item">
                      <label>{{filterFn('otherText', 'gameName')}}</label>
                      <div class="name">{{ detail.name }}</div>
                    </div>
                    <div class="item">
                      <label>{{filterFn('otherText', 'gameType')}}</label>
                      <div class="name">{{ filterCrumbsFn() }}</div>
                    </div>
                  </div>
                  <div v-if="!detail.isVertical" class="right-box">
                    <img v-if="detail.specImg" :src="detail.specImg" />
                  </div>
                  <img class="isVerticalImg" v-else :src="detail.specImg" />
                </div>

                <div class="control-box item flex-row-between">
                  <div>
                    <label>{{filterFn('otherText', 'difficulty')}}</label>
                    <div class="name">{{ difficultyFn(detail.difficulty) }}</div>
                  </div>
                  <div>
                    <label>{{filterFn('otherText', 'RTP')}}</label>
                    <div class="name">{{ detail.RTP }}%</div>
                  </div>
                  <div>
                    <label>{{filterFn('otherText', 'maximum')}}</label>
                    <!-- <div class="name">{{ detail.spec.bigWin }}</div> -->
                    <div class="name">{{ detail.maximum }}X</div>
                  </div>
                </div>

              </div>
            </div>

            <div class="item">
              <label>{{filterFn('otherText', 'compatible')}}</label>
              <div class="flex-row">
                <div
                  v-for="(item, index) in ['iOS', 'Android', 'Windows', 'MacOS', 'HTML5']"
                  :key="index"
                  class="icon-label"
                >
                  <i class="icon" :class="'icon-' + item"></i>
                  {{ systemConfig(item) }}
                </div>
              </div>
            </div>

            <div class="item">
              <label>{{filterFn('otherText', 'language')}}</label>
              <!-- TODO: 语言图标样式 -->
              <div class="flex-row flex-row2">
                <div
                  v-for="(item, index) in detail.language"
                  :key="index"
                  @click="langChange(item)"
                  class="icon-label icon-label2"
                >
                  <i class="icon" :style="styleFn(item)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Pcfooter :parseVal="parseVal" />
      </div>
    </div>
    <div id="gfg" v-show="gfgShow">
      <div id="lottie" class="imgBox"></div>
    </div>
  </div>
</template>

<script>
import PcHeader from '@/components/pc/PcHeader2.vue'
import Pcfooter from "@/components/pc/Pcfooter.vue";
import axios from 'axios'; 
import lottie from 'lottie-web'
import { getList } from '@/api'
import md5 from 'js-md5';
import {
  gameType,
  gameSystem,
  demoUrl,
} from '../../components/tool/GameConfig' // eslint-disable-line
export default {
  name: 'Details',
  components: {
    PcHeader,
    Pcfooter
  },
  data() {
    return {
      loadingShow: false,
      gfgShow: false,
      languageData: [],
      parseVal: [],
      langImg: [
        {
          img: 'cn',
          name: '简体中文'
        },
        {
          img: 'tw',
          name: '繁體中文'
        },
        {
          img: 'en',
          name: 'English'
        },
        {
          img: 'th',
          name: 'ภาษาไทย'
        },
        {
          img: 'ko',
          name: '한국인'
        },
        {
          img: 'ja',
          name: '日本語'
        },
        {
          img: 'vi',
          name: 'Tiếng Việt'
        },
        {
          img: 'es',
          name: 'Español'
        },
        {
          img: 'in',
          name: 'हिन्दी'
        },
        {
          img: 'pt',
          name: 'Português'
        }
      ],
      apiShow: false,
      lang: '',
      detail: {},
    }
  },
  mounted() {
    const _this = this
    const time = setInterval(function () {
      // 判断文档和所有子资源(图片、音视频等)已完成加载
      if (document.readyState === 'complete') {
        _this.loadingShow = true
        // 是否需要缓存
        // sessionStorage.setItem('loadingShow', '取消')
        clearInterval(time);
      }
    }, 500)
    this.lottieFn()
  },
  created() {
    // this.initData()
    this.lang = localStorage.getItem("LANG_NAME")
    this.loadApi()
  },
  computed: {
    // 类型名称
    typeName() {
      return (name) => {
        return gameType[name]
      }
    },
    // 系统配置
    systemConfig() {
      return (system) => {
        return gameSystem[system]
      }
    },
  },
  methods: {
    lottieFn() {
      var animationData = {"v":"5.6.9","fr":30,"ip":0,"op":64,"w":349,"h":192,"nm":"版本1","ddd":0,"assets":[{"id":"image_0","w":188,"h":204,"u":"/images/","p":"img_0.png","e":0},{"id":"image_1","w":195,"h":204,"u":"/images/","p":"img_1.png","e":0},{"id":"image_2","w":98,"h":109,"u":"/images/","p":"img_2.png","e":0},{"id":"image_3","w":95,"h":110,"u":"/images/","p":"img_3.png","e":0},{"id":"image_4","w":122,"h":122,"u":"/images/","p":"img_4.png","e":0},{"id":"image_5","w":122,"h":122,"u":"/images/","p":"img_5.png","e":0},{"id":"comp_0","layers":[{"ddd":0,"ind":1,"ty":2,"nm":"f2","refId":"image_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[4]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":26,"s":[4]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":30,"s":[100]},{"t":34,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":26,"s":[715,319.25,0],"to":[0,-6.542,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":30,"s":[715,280,0],"to":[0,0,0],"ti":[0,-6.542,0]},{"t":34,"s":[715,319.25,0]}],"ix":2},"a":{"a":0,"k":[94,102,0],"ix":1},"s":{"a":0,"k":[60,60,100],"ix":6}},"ao":0,"ip":0,"op":64,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":2,"nm":"g4","refId":"image_1","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[4]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":30,"s":[4]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":34,"s":[100]},{"t":38,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[771.75,319.5,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":30,"s":[771.75,319.5,0],"to":[0,-6.583,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":34,"s":[771.75,280,0],"to":[0,0,0],"ti":[0,-6.583,0]},{"t":38,"s":[771.75,319.5,0]}],"ix":2},"a":{"a":0,"k":[97.5,102,0],"ix":1},"s":{"a":0,"k":[60,60,100],"ix":6}},"ao":0,"ip":0,"op":64,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":2,"nm":"g3","refId":"image_1","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[4]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":22,"s":[4]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":26,"s":[100]},{"t":30,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":22,"s":[659.5,319.75,0],"to":[0,-6.625,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":26,"s":[659.5,280,0],"to":[0,0,0],"ti":[0,-6.625,0]},{"t":30,"s":[659.5,319.75,0]}],"ix":2},"a":{"a":0,"k":[97.5,102,0],"ix":1},"s":{"a":0,"k":[60,60,100],"ix":6}},"ao":0,"ip":0,"op":64,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":2,"nm":"g2","refId":"image_2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[771.75,319.5,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":30,"s":[771.75,319.5,0],"to":[0,-6.583,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":34,"s":[771.75,280,0],"to":[0,0,0],"ti":[0,-6.583,0]},{"t":38,"s":[771.75,319.5,0]}],"ix":2},"a":{"a":0,"k":[49,54.5,0],"ix":1},"s":{"a":0,"k":[60,60,100],"ix":6}},"ao":0,"ip":0,"op":64,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":2,"nm":"f1","refId":"image_3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[715,319.25,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":26,"s":[715,319.25,0],"to":[0,-6.542,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":30,"s":[715,280,0],"to":[0,0,0],"ti":[0,-6.542,0]},{"t":34,"s":[715,319.25,0]}],"ix":2},"a":{"a":0,"k":[47.5,55,0],"ix":1},"s":{"a":0,"k":[60,60,100],"ix":6}},"ao":0,"ip":0,"op":64,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":2,"nm":"g1","refId":"image_2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":22,"s":[659.5,319.75,0],"to":[0,-6.625,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":26,"s":[659.5,280,0],"to":[0,0,0],"ti":[0,-6.625,0]},{"t":30,"s":[659.5,319.75,0]}],"ix":2},"a":{"a":0,"k":[49,54.5,0],"ix":1},"s":{"a":0,"k":[60,60,100],"ix":6}},"ao":0,"ip":0,"op":64,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":2,"nm":"logo2","refId":"image_4","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":18,"s":[100]},{"t":26,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[561.25,375,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":4,"s":[561.25,375,0],"to":[0,-9.5,0],"ti":[0,10.167,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[561.25,318,0],"to":[0,-10.167,0],"ti":[0,-9.5,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":18,"s":[561.25,314,0],"to":[0,9.5,0],"ti":[0,-10.167,0]},{"t":22,"s":[561.25,375,0]}],"ix":2},"a":{"a":0,"k":[61,116,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":0,"s":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":4,"s":[100,76,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":8,"s":[100,128,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":18,"s":[100,107,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":22,"s":[100,107,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":26,"s":[100,76,100]},{"t":32,"s":[100,100,100]}],"ix":6}},"ao":0,"ip":0,"op":64,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":2,"nm":"logo1","refId":"image_5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[561.25,375,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":4,"s":[561.25,375,0],"to":[0,-9.5,0],"ti":[0,10.167,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[561.25,318,0],"to":[0,-10.167,0],"ti":[0,-9.5,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":18,"s":[561.25,314,0],"to":[0,9.5,0],"ti":[0,-10.167,0]},{"t":22,"s":[561.25,375,0]}],"ix":2},"a":{"a":0,"k":[61,116,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":0,"s":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":4,"s":[100,76,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":8,"s":[100,128,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":18,"s":[100,107,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":22,"s":[100,107,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":26,"s":[100,76,100]},{"t":32,"s":[100,100,100]}],"ix":6}},"ao":0,"ip":0,"op":64,"st":0,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":0,"nm":"预合成 1","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[168.25,96,0],"ix":2},"a":{"a":0,"k":[640,320,0],"ix":1},"s":{"a":0,"k":[62,62,100],"ix":6}},"ao":0,"w":1280,"h":640,"ip":0,"op":64,"st":0,"bm":0}],"markers":[]};
      var params = {
        container: document.getElementById('lottie'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData
      };
      lottie.loadAnimation(params);
    },
    loadApi() {
      this.apiShow = false
      getList({ 
        typeString: 'carousel,config,language,guideText,filmText,film,popularGameText,popularGame,config,propagateText,gamePresentationText,gamePresentation,aboutUsText,aboutUs,officialCertificationText,officialCertification,officialCertificationImg,partnersText,partnersImg,contactUsText,contactUs,gameOverviewText,otherText',
        pageIndex:1, pageSize: 999999, type: 'xxx'
      }).then(res => {
        if (res.data.code) {
          const val = res.data.data.items
          const parseVal = val.map(ele => {
            return { ...ele, ...JSON.parse(ele.jsonString)}
          })
          this.languageData = parseVal.filter(ele => ele.type === 'language')
          
          this.languageData.forEach((ele, index) => {
            if (!localStorage.getItem('LANG_NAME') && index === 0) {
              localStorage.setItem("LANG_NAME", ele.key1);
              this.lang = ele.key1
            }
          })
          if (!(this.languageData.map(ele => ele.key1).includes(localStorage.getItem('LANG_NAME')))) {
            localStorage.setItem("LANG_NAME", this.languageData[0].key1);
            this.lang = this.languageData[0].key1
          }

          this.parseVal = parseVal
          this.initData()
          console.log(parseVal.filter(ele => ele.type === 'config'), 's9d8a9s8d')
        }
      }).finally(() => {
        this.apiShow = true
        this.loadingShow = true
      })
    },
    styleFn(val) {
      const item = this.languageData.find(ele => ele.key1 === val.replace(/(^\s*)|(\s*$)/g, ""))
      return `background-image: url('https://admin.gfg888.com/td/api/photo/${item?.mapSrc}');`
    },
    initData() {
      const id = this.$route.query.id
      if (id) {
        const parseVal = this.parseVal.filter(ele => ele.type === 'config')
        const arr = parseVal.find((item) => Number(item.gameId) === Number(id))
        if (arr) {
          const findName = arr.descriptionData.find(ele => ele.name === this.lang)
          this.detail = {
            name: findName.game,
            isVertical: arr.isVertical,
            cover: this.imgFn(arr, '封面'),
            specImg: this.imgFn(arr, '手机图'),
            bgImg: this.imgFn(arr, '背景'),
            describe: findName.intro,
            type: arr.gameType,
            RTP: arr.RTP,
            maximum: arr.maximum,
            language: arr.language,
            difficulty: arr.difficulty,
            link: findName.link
          }
        }
      }
    },
    langChange(value) {
      this.$i18n.locale = value;
      localStorage.setItem("LANG_NAME", value);
      // this.isShowLang = false
      this.$router.go(0);
    },
    imgFn(arr, name) {
        const item = arr.computerData.find(ele => ele.name2 === name)
        if (this.lang === '简体中文') {
          if (item.chinese) {
            return 'https://admin.gfg888.com/td/api/photo/' + item.chinese
          } else {
            return null
          }
            
        } else {
          if (item.english) {
            return 'https://admin.gfg888.com/td/api/photo/' + item.english
          } else {
            return null
          }
        }
    },
    filterCrumbsFn() {
      const name = this.parseVal.filter(ele => ele.type === 'gameOverviewText')
      const item = name.find(ele => ele.key1 === '简体中文')
      const item2 = name.find(ele => ele.key1 === this.lang)
      let valName = ''
      for (var i in item) {
        if (item[i] === this.detail.type) {
          valName = item2[i]
        }
      }
      return valName
    },
    difficultyFn(val) {
      const mapName = {
        '低': 'low',
        '中': 'centre',
        '高': 'tall'
      }
      const name = this.parseVal.filter(ele => ele.type === 'otherText')
      const item = name.find(ele => ele.key1 === this.lang)
      return item ? item[mapName[val]] : ''
    },
    filterFn(val, key) {
      const name = this.parseVal.filter(ele => ele.type === val)
     
      const item = name.find(ele => ele.key1 === this.lang)
      console.log(name, item, 'itemitemitem')
      return item ? item[key] : ''
    },
    fish(i, lang, from){
      var d = new Date()
      var time = d.getTime();
      var uid = 'agent_' + Math.floor(Math.random()*(99999999 - 10000000 + 1) + 10000000);
      var mad5 = md5(uid)
      var key = "c3bf2511fbd0fc35d5ab2eb989106a92"
      let fromWhere = from.replace(/^www\./, '').replace(/\.com$/, '');
      // let fromWhere = from;

      switch (fromWhere) {
        case 'gfg.game':
        fromWhere = 'http://www.gfg888.com/pc/gameDisplay'
        break;
        case 'gfg.bet':
        fromWhere = 'https://www.gfg.bet/pc/gameDisplay'
        break;
        case 'gfg.win':
        fromWhere = 'https://www.gfg.win/pc/gameDisplay'
        break;
        case 'gfg.online':
        fromWhere = 'https://www.gfg.online/pc/gameDisplay'
        break;
        case 'gfg.fun':
        fromWhere = 'https://www.gfg.fun/pc/gameDisplay'
          break;
        case 'gfg126':
        fromWhere = 'https://gfg126.com/pc/gameDisplay'
          break;
        default:
        fromWhere = 'http://www.gfg888.com/pc/gameDisplay'
      }

      var param = {
        account: uid,
        gameId: Number(i),
        orderId: '1103828' + time + uid,
        money: 10000.00,
        ip: '168.0.0.1',
        agent: '40121',
        companyKey: '40121',
        platform: 1,
        theme: 'S004',
        token: mad5,
        timestamp: time,
        languageType: lang,
        isH5Lobby: true,
        lobbyType: 0,
        mac: uid,
        exitUrl: fromWhere
      }
      var paramjson = JSON.stringify(param)
      var Authorization = md5(paramjson + key)
      axios({
        method: 'POST',
        url: 'https://admin.gfg888.com/td/api/Forward/Login',
        data: {
          RequestParam: paramjson,
          Authorization
        }
      }).then(response => {
        if (response.data.code === 200) {
          window.open(response.data.data, '_self');
        } else {
          // alert(response.data.data)
          this.gfgShow = false
          this.apiShow = true
        }
      })
    },
    getDomainName(url) {  
      let domain = url.split('//')[1]; // 切割出域名部分  
      domain = domain.split('.').slice(-2).join('.'); // 获取域名，忽略顶级域名  
      return domain;  
    },
    toLink() {
      // const findVal = this.languageData.find(ele => ele.name === localStorage.getItem("LANG_NAME"))
      // let url = `${demoUrl}?gameId=${this.$route.query.id}&lang=${findVal ? findVal.mapping : ''}`
      // window.open(url)
      if (this.detail?.link) {
        window.open(this.detail.link)
      } else {
        const findVal = this.languageData.find(ele => ele.name === localStorage.getItem("LANG_NAME"))
        console.log(demoUrl, findVal, 's9s94d5x')
        // let url = `${demoUrl}?gameId=${this.$route.query.id}&lang=${findVal ? findVal.mapping : ''}`
        // window.open(url)
        this.gfgShow = true
        this.apiShow = false
        this.$nextTick(() => {
          this.fish(this.$route.query.id, findVal ? findVal.mapping : '', this.getDomainName(location.origin));
        })
      }
      
    },
  },
}
</script>

<style lang="less" scoped>
@design-width: 1920;
.px2vw(@name, @px) {
  @{name}: (@px / @design-width) * 100vw;
}
.color9{
  color: #999;
  font-size: 20 ./ @design-width * 100vw;
}
.details-page {
  background: #000;
  height: 100vh;
  .flex-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
  }
  .flex-row2 {
    width: 450 ./ @design-width * 100vw;
  }

  .flex-row-between {
    display: flex;
    justify-content: space-between;
  }

  .flex-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    right: 0;
    top: 0;
  }

  img {
    max-width: 100%;
  }

  .game-content {
    .px2vw(height, 1080);
    position: relative;
    background-color: #ddd;
    background-size: cover;
    width: 100%;
    .game-cover {
      .px2vw(width, 270);
      .px2vw(height, 360);
      .px2vw(bottom, 140);
      .px2vw(left, 210);
      position: absolute;
      z-index: 1;
      background-color: antiquewhite;
      border-radius: 25 ./ @design-width * 100vw;
    }

    .info-wrap {
      padding: 20px 7vw 50px 27vw;
      background-color: rgba(0, 0, 0, 0.6);
      line-height: 1.2;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      .nav {
        font-size: 20 ./ @design-width * 100vw;

        color: #ccc;
        a {
          color: #ccc;
        }
      }

      .game-title {
        margin: 20 ./ @design-width * 100vw 0 30 ./ @design-width * 100vw;
        color: #fff;
        font-size: 35 ./ @design-width * 100vw;
      }
      .describe {
        // flex: 1;
        font-size: 24 ./ @design-width * 100vw;
        color: #ddd;
        margin-right: 30 ./ @design-width * 100vw;
        width: 80%;
        div{
          width: 60%;
        }
        .px2vw(height, 150);
      }

      .link-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor:url('../../assets/img/pc/finger.png'),auto;
        .px2vw(width, 164);
        .px2vw(height, 53);
        .px2vw(margin-bottom, 20);
        border-radius: 30 ./ @design-width * 100vw;
        color: #fff;
        font-size: 24 ./ @design-width * 100vw;
        font-family: 'fontText';
        background-image: linear-gradient(90deg, #7E429C 0%, #501B97 100%);
      }
    }
  }
  .game-rightBox {
    display: flex;
    margin: 3.1vw 14.8vw 2.6vw;
    justify-content: space-between;
    position: relative;
    font-size: 20 ./ @design-width * 100vw;
    background-color: #000;
    .game-specs {
      // padding: 60px 150px 50 ./ @design-width * 100vw;
      margin-top: 100 ./ @design-width * 100vw;
      color: #fff;

      .left-info {
        // flex: 1;
        .specs-title {
          font-family: 'fontText';
          font-size: 50 ./ @design-width * 100vw;
        .px2vw(margin-bottom, 30);
        }
      }
      .item {
        .px2vw(margin-bottom, 65);
        label {
          display: inline-block;
        .px2vw(margin-bottom, 15);
          font-size: 29 ./ @design-width * 100vw;
          color: #575F69;
        }
        .name {
          font-size: 34 ./ @design-width * 100vw;
        }
        .icon-label2{
          width: 20%;
          margin: 15 ./ @design-width * 100vw 0;
          margin-right: 0 !important;
          justify-content: start!important;
          
          .icon{
            width: 35 ./ @design-width * 100vw !important;
            height: 35 ./ @design-width * 100vw !important;
            cursor:url('../../assets/img/pc/finger.png'),auto;
          }
        }
        .icon-label {
          display: flex;
          align-items: center;
          justify-content: center;
          .px2vw(margin-right, 24);
          font-size: 24 ./ @design-width * 100vw;

          .icon {
          .px2vw(width, 28);
          .px2vw(height, 28);
          .px2vw(margin-right, 10);
            background-repeat: no-repeat;
            background-size: contain;
            // filter: grayscale(95%);
          }

          .icon-iOS {
            background-image: url('../../assets/img/system/iOS.png');
          }
          .icon-Android {
            background-image: url('../../assets/img/system/Android.png');
          }
          .icon-Windows {
            background-image: url('../../assets/img/system/Windows.png');
          }
          .icon-MacOS {
            background-image: url('../../assets/img/system/MacOS.png');
          }
          .icon-HTML5 {
            background-image: url('../../assets/img/system/HTML5.png');
          }

          // 支持的语言图标
          .icon-cn {
            background-image: url('../../assets/img/lang/cn.png');
          }
          .icon-tw {
            background-image: url('../../assets/img/lang/tw.png');
          }
          .icon-en {
            background-image: url('../../assets/img/lang/en.png');
          }
          .icon-ko {
            background-image: url('../../assets/img/lang/ko.png');
          }
          .icon-th {
            background-image: url('../../assets/img/lang/th.png');
          }
          .icon-vi {
            background-image: url('../../assets/img/lang/vi.png');
          }
          .icon-pt {
            background-image: url('../../assets/img/lang/pt.png');
          }
          .icon-es {
            background-image: url('../../assets/img/lang/es.png');
          }
          .icon-in {
            background-image: url('../../assets/img/lang/in.png');
          }
          .icon-ja {
            background-image: url('../../assets/img/lang/ja.png');
          }
        }
      }
    }
    .right-box {
          .px2vw(margin-left, 200);
      position: relative;
      top: -70 ./ @design-width * 100vw;
      img {
        width: 600 ./ @design-width * 100vw;
        // height: 393 ./ @design-width * 100vw;
      }
    }
    .isVerticalImg {
      width: 300 ./ @design-width * 100vw;
      height: 600 ./ @design-width * 100vw;
      position: absolute;
      right: 0;
      top:0;
    }
  }
  .copyright {
    font-family: 'fontText';
    padding: 1rem;
    width: 100%;
    background: #000;
    color: rgba(255, 255, 255, 0.5);
    font-size: 14 ./ @design-width * 100vw;
    text-align: center;
  }
}
.control-box {
  width: 700 ./ @design-width * 100vw;
}
.main {
  background: #000;
}
.cursorBox {
  cursor:url('../../assets/img/pc/cursor.png'),auto;
}
.bg000 {
  background: #000;
  height: 100vh;
}

.imgBox {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 27.2vw;
  height: 15vw;
}

</style>
